import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent, Badge as MantineBadge } from '@mantine/core';
const _Badge = forwardRef(({ style, ...props }, ref) => {
    return (_jsx(MantineBadge, { ...props, ref: ref, style: {
            // By default badges (mostly containing icons) should not shrink inside flex containers
            flexShrink: 0,
            ...style,
        } }));
});
_Badge.displayName = 'Button';
export const Badge = createPolymorphicComponent(_Badge);
